import React, { useEffect, useState } from "react";
import GovernorateProfile from "./GovernorateProfile";
import { GovernyInfo, PlayerInfo } from "../../../../lib/types";
import { getData } from "../../../../lib/commonFunctions";

interface IProps {
  governorate: GovernyInfo;
}

const OtherGovernorateProfile = ({ governorate }: IProps) => {
  const [player, setPlayer] = useState<PlayerInfo | null>(null);

  useEffect(() => {
    const getPlayer = async () => {
      const playerData = await getData(`/api/info/player/${governorate.player.id}`);
      setPlayer(playerData);
    };
    getPlayer();
  }, [])

  return player
    ? <GovernorateProfile governorate={governorate} player={player} owner={false}/>
    : <></>;
}

export default OtherGovernorateProfile;
